export const selectCountries = (store) => store.countries.items;
export const selectError = (store) => store.countries.error;
export const selectIsLoading = (store) => store.countries.isLoading;
export const selectIsDetailsShown = (store) => store.countries.isDetailsShown;
